//update along with app/lib/enums/temporary_product_image_enums.py
const TemporaryProductImageEnums = {
  NOT_APPLICABLE: 'NOT_APPLICABLE',
  APPROVED: 'APPROVED',
  NOT_SURE: 'NOT_SURE',
  AI_SUGGESTED: 'AI_SUGGESTED',
  QA_TRAINEE_APPROVED: 'QA_TRAINEE_APPROVED',
  QA_TRAINEE_NOT_APPLICABLE: 'QA_TRAINEE_NOT_APPLICABLE',
};

const TemporaryProductImagesDisplayValues = {
  [TemporaryProductImageEnums.NOT_APPLICABLE]: 'Not Applicable',
  [TemporaryProductImageEnums.APPROVED]: 'Approved',
  [TemporaryProductImageEnums.NOT_SURE]: 'Not Sure',
  [TemporaryProductImageEnums.AI_SUGGESTED]: 'AI Suggested',
  [TemporaryProductImageEnums.QA_TRAINEE_APPROVED]: 'QA Trainee Approved',
  [TemporaryProductImageEnums.QA_TRAINEE_NOT_APPLICABLE]: 'QA Trainee Not Applicable',
};

export { TemporaryProductImageEnums, TemporaryProductImagesDisplayValues };
